import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _Product } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { toast } from "react-toastify";


interface Props {
    idProduct: number;
    idSelector: number;
    onChange: Function;
    label?: string
}

export const SelectProductVariant = ({ idProduct, idSelector, onChange, label }: Props) => {

    const { instance, lista, setLista } = useDataBean(_Product)
    const [id, setID] = useState(idSelector ?? "")

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector)
        }
    }, [idSelector])

    useEffect(() => {
        if (idProduct) {
            getLista();
        }
    }, [idProduct])

    const getLista = () => {
        instance.getProductVariantCatalog(idProduct).then(
            (resp) => {
                setLista(resp);
            }
        ).catch(
            err => {
                console.log(err)
            }
        )
    }

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            onChange(selectedId)
        }
    };

    return (
        <>
            <label>{label ?? "Talla/Variante"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={NaN}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDProductVariant} >{item.DataBeanProperties.Reference ?? "No REF"} - {item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}